import { render, staticRenderFns } from "./uploadImginbatch.vue?vue&type=template&id=4b3af474&scoped=true"
import script from "./uploadImginbatch.vue?vue&type=script&lang=js"
export * from "./uploadImginbatch.vue?vue&type=script&lang=js"
import style0 from "./uploadImginbatch.vue?vue&type=style&index=0&id=4b3af474&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3af474",
  null
  
)

export default component.exports